<template>
  <div class="tool-box">
    <span class="login" @click="dialogVisible = true">
      <img src="~/img/icon_user.png" alt="">{{ t('home.btn2') }}
    </span> 丨
    <client-only>
      <el-dropdown class="language"  trigger="click" @command="handleCommand">
        <span class="el-dropdown-link">
          <img src="~/img/icon_language.png" alt="">
          <span v-for="x in langList">
            <template v-if="locale == x.dictValue">{{ x.dictLabel }}</template>
          </span>
          <el-icon class="el-icon--right">
            <CaretBottom />
          </el-icon>
        </span>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item v-for="y in langList" :key="y.value" :command="y" :disabled="y.dictValue == locale">{{y.dictLabel}}</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </client-only>
    <register v-model="dialogVisible" />
  </div>
</template>

<script lang="ts" setup>

  import { useI18n } from 'vue-i18n'
  const { t, locale  } = useI18n();

  const dialogVisible = ref(false)
  const langList: any = ref([])
  const getList = async() => { // 获取数据
    try {
      const response = await listDictData('sys_language_type');
      if(response.data.length){
        langList.value = response.data
      }else{
      }
    } catch (error) {
    }
  }
  getList()

  const handleCommand = (command: string | number | object | any) => {
    const cookieLang  = useCookie("lang");
    cookieLang.value = locale.value = command.dictValue;
  }

</script>

<style scoped lang="scss">
  .tool-box{
    color: #2f2f2f;
    white-space: nowrap;
    span{
      cursor: pointer;
      line-height: 25px;
    }
    img{
      vertical-align: middle;
      margin-right: 7px;
    }
    .login{
      img{
        height: 22px;
      }
    }
    .language{
      color: inherit;
      font-size: inherit;
      img{
        height: 25px;
      }
      .el-dropdown-link:focus{
        outline: none;
      }
      
    }
  }
</style>